import {breakpoints} from "../App.style";

export const isMobileInLandscapeMode = () => {
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isMobileSize = window.matchMedia(`(max-height: ${breakpoints.mobile})`).matches;
    const isLandscape = window.matchMedia('(orientation: landscape)').matches;

    return isMobileDevice && isMobileSize && isLandscape;
};
